import { getAnalyticsWebClientPromise } from '@atlassian/jira-product-analytics-web-client-async';

export type AnalyticsEvent = {
	action: string;
	actionSubject: string;
	source: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	attributes: any;
};

export type AnalyticsClient = {
	sendOperationalEvent: (event: AnalyticsEvent) => void;
};

export const getAnalyticsInstance = async (): Promise<AnalyticsClient> => {
	const analyticsWebClient = await getAnalyticsWebClientPromise();
	return analyticsWebClient.getInstance();
};
